import { makeStyles } from "@material-ui/styles"

const statsStyles = makeStyles(() => ({
  paper: {
    backgroundColor: "rgba(0, 0, 0, 0.5)",
    padding: "30px 50px 10px 50px",
    textAlign: "center",
  },
  title: {
    textAlign: "center",
    margin: "20px 0px",
  },
}))

export default statsStyles
